<div class="wrap">
  <div class="textgroup">
    <div class="text">Thanks for your suggestion</div>
    <div class="text">Click anywhere to go back</div>
  </div>
  <img src="images/logo_myviewboard.svg" alt="" class="logo">
</div>